var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({textAlign:_vm.textAlign})},[_c('img',{style:({width:_vm.widthPx+'px',height:_vm.heightPx+'px'}),attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }